// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2uq7m","buttons":"PendingPaymentAlert_buttons__16AVI"};